module.exports = __webpack_public_path__ + "static/media/2.d3039964.svg";